import { APP_NOTIFICATION_TYPE } from '../../app/App.constants';

export const LOB_DETAILS_FORM_NAME = 'lobDetails';
export const LOB_PROPERTIES_FORM_NAME = 'lobProperties';
export const LOB_CHANNELS_FORM_NAME = 'lobChannels';
export const MERCHANT_TABS_ORDER_FORM_NAME = 'merchantTabsOrder';

export const PLATFORMS_MAIN = ['web', 'mobile', 'ios', 'android'];

export const PROPERTIES_LIST = [
  {
    display: 'Homepage Redirect URL',
    key: 'homepage_redirect_url',
    type: 'string',
    defaultValue: '', // @TODO Confirm this
  },
  {
    display: 'Confirmation page URL',
    key: 'confirmation_page_url',
    type: 'string',
    defaultValue: '',
  },
  {
    display: 'Override Payment Options',
    key: 'payment_options_override',
    type: 'boolean',
    defaultValue: false, // @TODO Confirm this
  },
  {
    display: 'Enable discount',
    key: 'discount_enable',
    type: 'boolean',
    defaultValue: false,
  },
  {
    display: 'Enable full discount',
    key: 'full_discount_enable',
    type: 'boolean',
    defaultValue: false,
  },
  {
    display: 'Enable faces',
    key: 'faces_enable',
    type: 'boolean',
    defaultValue: false,
  },
  {
    display: 'Enable processing fees',
    key: 'processing_fees_enable',
    type: 'boolean',
    defaultValue: false,
  },
  {
    display: 'Read discount flag from LOB',
    key: 'read_discount_flag_from_lob',
    type: 'boolean',
    defaultValue: false,
  },
  {
    display: 'Enable sending feedback to Red Shield',
    key: 'send_feedback_redshield_enable',
    type: 'boolean',
    defaultValue: false,
  },
  {
    display: 'Enable One-click Payment',
    key: 'one_click_payment',
    type: 'boolean',
    defaultValue: false,
  },
  {
    display: 'Order Expiry time (mins)',
    key: 'order_expiry_time',
    type: 'string',
    defaultValue: 45, // @TODO confirm this value
  },
  {
    display: 'Transaction Expiry time (mins)',
    key: 'transaction_expiry_time',
    type: 'string',
    defaultValue: 45, // @TODO confirm this value
  },
  {
    display: 'Enable Expresspay Checkout',
    key: 'expresspay_checkout_enable',
    type: 'boolean',
    defaultValue: false,
  },
  {
    display: 'Enable fraud check',
    key: 'fraud_check_enable',
    type: 'boolean',
    defaultValue: false,
  },
];

export const PAGE_DETAILS = {
  ProcessingFeesList: {
    Id: 'ID',
    LobName: 'Lob Name',
    Currency: 'Currency',
    FeesDisplayCode: 'Fees Display Code',
    FeesType: 'Fees Type',
    MethodCode: 'Method Code',
    PaymentMode: 'Payment Mode',
    ProcessingFees: 'Processing Fees',
    CreatedBy: 'Created By',
    CreatedAt: 'Created At',
    ModifiedBy: 'Modified By',
    UpdatedAt: 'Updated At',
  },
  MaintenanceRuleList: {
    // Page
    PageTitle: 'Maintenance Rules',
    PageDescription: 'List of the payment maintenance rules',

    // Buttons
    CreateButton: 'Add New Rule',

    // Dialogs
    DeleteConfirmationTitle: 'Delete Maintenance Rule',
    DeleteConfirmationMessage:
      'Are you sure you want to delete the selected maintenance rule?',

    // Columns
    IdColumn: 'ID',
    StatusColumnLabel: 'Status',
    LineOfBusinessColumnLabel: 'Line of business',
    PlatformColumnLabel: 'Platform name',
    CurrencyColumnLabel: 'Currency',
    MethodCodeColumnLabel: 'Method code',
    BannerMessageColumnLabel: 'Banner message',
    StartDateColumnLabel: 'Start date',
    EndDateColumnLabel: 'End date',
    DisplayBehaviorColumnLabel: 'Display behavior',
    ActionsColumnLabel: 'Actions',

    // Fields
    LobField: 'Select line of business',
    PlatformField: 'Select platform',
    MethodCodeField: 'Select method code',
    CurrencyField: 'Select currency',
    MessageKeyField: 'Enter message key',
    MessageField: 'Enter message',
    BannerTypeField: 'Select banner type',
    DisplayBehaviorField: 'Select display behavior',
    StartTimeField: 'Select start time',
    EndTimeField: 'Select end time',

    RequiredField: 'Required field',
    // NumberField: 'Invalid value',

    // API Actions
    DeleteSuccess: 'Yay! Maintenance rule has been deleted successfully.',
    DeleteFailure:
      'Oops! Something went wrong while deleting the maintenance rule.',
  },
  MaintenanceRuleCreate: {
    // Form Fields
    LobField: 'Select line of business',
    PlatformField: 'Select platform',
    MethodCodeField: 'Select methods',
    CurrencyField: 'Select currencies',
    MessageKeyField: 'Enter message key',
    MessageField: 'Enter default message (en-gb)',
    BannerTypeField: 'Select banner type',
    DisplayBehaviorField: 'Select display behavior',
    StartTimeField: 'Select start date & time',
    EndTimeField: 'Select end date & time',

    // Field Validation
    FormRequiredFieldError: 'This is a required field',

    // API Actions
    CreateSuccess: 'Yay! Maintenance rule has been created successfully.',
    CreateFailure:
      'Oops! Something went wrong while creating the maintenance rule.',
  },
};

export const COLUMN_WIDTH = {
  XM: 50,
  SM: 100,
  MD: 150,
  LG: 200,
  XL: 250,
  XXL: 350,
  XXXL: 550,
};

export const PAYMENT_MODE_OPTIONS = [
  'CREDIT_CARD',
  'DIRECT_DEBIT',
  'INSTALMENT',
  'WALLET',
  'OTC',
  'QR',
  'BIGPAY',
];

export const FEES_TYPE_OPTIONS = ['ABSOLUTE', 'PERCENTAGE'];

export const PROCESSING_FEES_LIST_COLUMNS = [
  {
    field: 'id',
    headerName: PAGE_DETAILS.ProcessingFeesList.Id,
    width: COLUMN_WIDTH.SM,
    align: 'center',
    headerAlign: 'center',
  },
  {
    field: 'paymentMode',
    headerName: PAGE_DETAILS.ProcessingFeesList.PaymentMode,
    width: COLUMN_WIDTH.MD,
    align: 'center',
  },
  {
    field: 'currency',
    headerName: PAGE_DETAILS.ProcessingFeesList.Currency,
    width: COLUMN_WIDTH.SM,
    align: 'center',
  },
  {
    field: 'methodCode',
    headerName: PAGE_DETAILS.ProcessingFeesList.MethodCode,
    width: COLUMN_WIDTH.SM,
    align: 'center',
  },
  {
    field: 'processingFees',
    headerName: PAGE_DETAILS.ProcessingFeesList.ProcessingFees,
    width: COLUMN_WIDTH.MD,
    align: 'center',
  },
  {
    field: 'feesType',
    headerName: PAGE_DETAILS.ProcessingFeesList.FeesType,
    width: COLUMN_WIDTH.SM,
    align: 'center',
  },
  {
    field: 'feesDisplayCode',
    headerName: PAGE_DETAILS.ProcessingFeesList.FeesDisplayCode,
    width: COLUMN_WIDTH.LG,
    align: 'center',
  },
  {
    field: 'actions',
    type: 'actions',
    headerName: 'Action',
    width: 80,
  },
  {
    field: 'createdAt',
    headerName: PAGE_DETAILS.ProcessingFeesList.CreatedAt,
    width: COLUMN_WIDTH.SM,
    align: 'center',
  },
  {
    field: 'updatedAt',
    headerName: PAGE_DETAILS.ProcessingFeesList.UpdatedAt,
    width: COLUMN_WIDTH.SM,
    align: 'center',
  },
  {
    field: 'createdBy',
    headerName: PAGE_DETAILS.ProcessingFeesList.CreatedBy,
    width: COLUMN_WIDTH.LG,
    align: 'center',
  },
  {
    field: 'modifiedBy',
    headerName: PAGE_DETAILS.ProcessingFeesList.ModifiedBy,
    width: COLUMN_WIDTH.LG,
    align: 'center',
  },
];
export const MAINTENANCE_RULE_LIST_COLUMNS = [
  {
    field: 'active',
    headerName: PAGE_DETAILS.MaintenanceRuleList.StatusColumnLabel,
    width: COLUMN_WIDTH.SM,
    align: 'center',
  },
  {
    field: 'merchant',
    headerName: PAGE_DETAILS.MaintenanceRuleList.LineOfBusinessColumnLabel,
  },
  {
    field: 'platform',
    headerName: PAGE_DETAILS.MaintenanceRuleList.PlatformColumnLabel,
  },
  {
    field: 'currency',
    headerName: PAGE_DETAILS.MaintenanceRuleList.CurrencyColumnLabel,
    width: COLUMN_WIDTH.SM,
  },
  {
    field: 'methodCode',
    headerName: PAGE_DETAILS.MaintenanceRuleList.MethodCodeColumnLabel,
  },
  {
    field: 'message',
    headerName: PAGE_DETAILS.MaintenanceRuleList.BannerMessageColumnLabel,
    width: COLUMN_WIDTH.XXL,
  },
  {
    field: 'displayBehavior',
    headerName: PAGE_DETAILS.MaintenanceRuleList.DisplayBehaviorColumnLabel,
    align: 'center',
  },
  {
    field: 'startTime',
    headerName: PAGE_DETAILS.MaintenanceRuleList.StartDateColumnLabel,
    width: COLUMN_WIDTH.SM,
  },
  {
    field: 'endTime',
    headerName: PAGE_DETAILS.MaintenanceRuleList.EndDateColumnLabel,
    width: COLUMN_WIDTH.SM,
  },
  { field: 'createdBy', headerName: 'Created By', width: COLUMN_WIDTH.LG },
];

export const MAINTENANCE_RULE_DISPLAY_BEHAVIOR = {
  HIDE: 'HIDE',
  DISABLE: 'DISABLE',
};

export const MAINTENANCE_RULE_DISPLAY_BEHAVIOR_LIST = [
  {
    name: 'Hide',
    code: MAINTENANCE_RULE_DISPLAY_BEHAVIOR.HIDE,
  },
  {
    name: 'Disable',
    code: MAINTENANCE_RULE_DISPLAY_BEHAVIOR.DISABLE,
  },
];

export const MAINTENANCE_RULE_BANNER_TYPE_LIST = [
  {
    name: 'Error',
    code: APP_NOTIFICATION_TYPE.ERROR,
  },
  {
    name: 'Success',
    code: APP_NOTIFICATION_TYPE.SUCCESS,
  },
  {
    name: 'Warning',
    code: APP_NOTIFICATION_TYPE.WARNING,
  },
  {
    name: 'Info',
    code: APP_NOTIFICATION_TYPE.INFO,
  },
  {
    name: 'New Info - v6',
    code: APP_NOTIFICATION_TYPE.INFO_V6,
  },
  {
    name: 'New Warning - v6',
    code: APP_NOTIFICATION_TYPE.WARNING_V6,
  },
];

export const MAINTENANCE_RULE_DEFAULT_MESSAGE =
  'Bank System under Maintenance. Please try again later.';

export const MAINTENANCE_RULE_DEFAULT_BANNER_TYPE =
  MAINTENANCE_RULE_BANNER_TYPE_LIST.find(
    ({ code }) => code === APP_NOTIFICATION_TYPE.INFO,
  );

export const MAINTENANCE_RULE_DEFAULT_DISPLAY_BEHAVIOR =
  MAINTENANCE_RULE_DISPLAY_BEHAVIOR_LIST.find(
    ({ code }) => code === MAINTENANCE_RULE_DISPLAY_BEHAVIOR.DISABLE,
  );

export const MAINTENANCE_RULE_MAX_METHODS = 20;

export const MAINTENANCE_RULE_MAX_CURRENCIES = 1;

export const MAINTENANCE_RULE_METHOD_CODES_PARTIAL_PAYMENT = [
  { id: 'P1', code: 'DISCOUNT', name: 'Discounts' },
  { id: 'P2', code: 'LOYALTY', name: 'AirAsia points' },
  { id: 'P3', code: 'EGV', name: 'Travel voucher' },
  { id: 'P4', code: 'CREDITSHELL', name: 'Credit account' },
];

export const MAINTENANCE_RULE_DATE_TIME_FORMAT = 'DD/MM/YYYY (hh:mm A)';

export const MAINTENANCE_RULE_DATE_FORMAT = 'DD/MM/YYYY';
